import { Typography } from 'bluematter';
import React from 'react';
import './Header.css';
/**
 * Sidebar header
 *
 * @param {*} props
 * @returns sidebar header with a children title and an optional toggle button
 * @version 1.0.1
 * @example <SidebarHeader>child</SidebarHeader>
 */
const SidebarHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="sidebar-header">
      {children && <Typography variant="body2">{children}</Typography>}
    </div>
  );
};

export default SidebarHeader;
